import SIGNIN_FROM from '../actionTypes/SignInSliderActionTypes';

function SignInSliderReducer(state = {}, action) {
    switch (action.type) {
        case SIGNIN_FROM:
            return action.payload;
        default:
            return state;
    }
}

export default SignInSliderReducer;
